// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"8b34c008","845":"392f8e0c"}[chunkId] + ".chunk.js";
};